
import React from "react";

const CircleIcon = ({ width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 50}
    height={height || 50}
    fill={"none"}
    viewBox="0 0 24 24"
  >
    <path
      stroke={fill || "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
);

export default CircleIcon;
